import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBRLocale from "date-fns/locale/pt-BR";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./utils/ProtectedRoute";
import MainLayout from "./layouts/MainLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SisfunerPayment from "./pages/Payment/Sisfuner";
import GscemiPayment from "./pages/Payment/Gscemi";
import TransactionsHistory from "./pages/TransactionsHistory";
import { useAuth } from "./contexts/AuthContext";
import { themes } from "./themes";

function ThemedApp({ children }) {
  const { system } = useAuth();
  const currentTheme = themes[system] || themes.default;
  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={ptBRLocale}
      >
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemedApp>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={ptBRLocale}
          >
            <Routes>
              <Route path="/login" element={<Login />} />

              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <MainLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="payment/sisfuner" element={<SisfunerPayment />} />
                <Route path="payment/gscemi" element={<GscemiPayment />} />
                <Route
                  path="transactions-history"
                  element={<TransactionsHistory />}
                />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </LocalizationProvider>
        </ThemedApp>
      </AuthProvider>
    </Router>
  );
}

export default App;
